const Wrapper = (props) => props.children;

export default Wrapper;